import React, { useState, useEffect } from "react";
import "../Division/div.css";
import { Grid } from "@mui/material";
import { images } from "../../config/images";
import {
  productData,
  productdetail,
  rangeproduct,
} from "../../config/services";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { slugify } from "../../utils/slugify";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import { ProductDetailShimmer } from "../../components/Shimmer/Shimmer";

const Division1 = () => {
  const [productAPIData, setProductAPIData] = useState([]);
  const [rangeProductAPIData, setRangeProductAPIData] = useState([]);
  const [productdetailData, setProductDetailsData] = useState([]);
  const [catogoryId, setCategoryId] = useState("");
  const [subcategoriesId, setSubCategoryID] = useState("");
  const [rangeId, setRangeId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [detailLoading, setDetailLoading] = useState(true);
  const [rangeLoading, setRangeLoading] = useState(false);
  const param = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    handleproductdetail();
  }, [rangeId]);

  useEffect(() => {
    if (catogoryId && subcategoriesId) {
      handleRangeProduct();
    }
  }, [catogoryId, subcategoriesId]);
  useEffect(() => {
    handleProduct();
  }, []);



  const handleCategoryClick = (category) => {
    setCategoryId(category.categories_id);
  };


  const handleProduct = async () => {
    const params = {
      categories_id: 5,
      // categories_id: param.id,
      subcategories_id: 8,
    };

    try {
      const jsonParams = JSON.stringify(params);

      const resp = await productData(currentPage, { params });

      if (resp.data.code === 200 || resp.data.code === 201) {
        setProductAPIData(resp.data.responseBody);
      }
    } catch (error) {
      console.log("Error in handleProduct:", error);
    }
  };

  const handleRangeProduct = async () => {
    const params = {
      categories_id: catogoryId,
      subcategories_id: subcategoriesId,
    };

    try {
      setRangeLoading(true);
      const jsonParams = JSON.stringify(params);

      const resp = await rangeproduct({ params });

      setRangeProductAPIData(resp?.data?.responseBody);
    } catch (error) {
      console.log("handleSubcategory error:", error);
    } finally {
      setRangeLoading(false);
    }
  };

  const handleproductdetail = async () => {
    const id = rangeId || location.state?.productId;
    if (!id) return;

    const params = {
      id: id,
    };
    try {
      setDetailLoading(true);
      const resp = await productdetail({ params });
      setProductDetailsData(resp?.data?.responseBody);
      setCategoryId(resp?.data?.responseBody[0]?.category_id);
      setSubCategoryID(resp?.data?.responseBody[0]?.subcategory_id);
    } catch (error) {
      console.log("handleproductdetail error:", error);
    } finally {
      setDetailLoading(false);
    }
  };
  const breadcrumbsData = [
    { label: "Home", url: "/" },
    {
      label: "Division",
      url: `/division/${param.categorySlug}`,
    },
    {
      label: param.categorySlug?.charAt(0).toUpperCase() + param.categorySlug?.slice(1),
      url: `/division/${param.categorySlug}`,
    },
    { label: productdetailData[0]?.title, url: productdetailData[0]?.id },
  ];
  const handleRangeClick = (product) => {
    navigate(`/division/${param.categorySlug}/${slugify(product.title)}`, {
      state: { productId: product.id }
    });
    setRangeId(product.id);
  }

  return (
    <div className="division-page-wrap">
      <div className="about-us-container">
        <div className="molecule left">
          <img
            src={images.leftSpirrel}
            alt="Left Molecule"
            className="left-spinner"
          />
        </div>
        <div className="about-text">
          {detailLoading ? (
            <div className="shimmer-placeholder-neuro" style={{ height: "36px", width: "250px", margin: "0 auto 8px", borderRadius: "4px" }} />
          ) : (
            <h1>{productdetailData[0]?.title}</h1>
          )}
          <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
        </div>
        <div className="molecule right">
          <img
            src={images.rightSpirrel}
            alt="Right Molecule"
            className="right-spinner"
          />
        </div>
      </div>

      {detailLoading ? (
        <ProductDetailShimmer />
      ) : (
        <div className="common-sec product-detail-sec">
          <div className="product-detail-card">
            <Grid container spacing={4} alignItems="center">
              {productdetailData?.map((product) => (
                <React.Fragment key={product.id}>
                  <Grid item xs={12} md={6}>
                    <div className="product-detail-image-wrap">
                      <img
                        className="product-detail-image"
                        src={product?.image}
                        alt={product?.title || "Product"}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="product-detail-info">
                      <h1 className="product-detail-title">{product?.title}</h1>
                      {product?.subtitle && (
                        <p className="product-detail-subtitle">{product?.subtitle}</p>
                      )}
                      <div className="product-detail-description">
                        {/<\/?[a-z][\s\S]*>/i.test(product?.description) ? (
                          <div dangerouslySetInnerHTML={{ __html: product?.description }} />
                        ) : (
                          <p>{product?.description}</p>
                        )}
                      </div>
                      {product?.pdf && (
                        <div className="product-detail-actions">
                          <button
                            type="button"
                            className="product-read-more-btn"
                            onClick={() => navigate(`/division/${param.categorySlug}/${slugify(product.title)}/pdf/${product.id}/`, {
                              state: { productId: product.id }
                            })}
                          >
                            Read More
                          </button>
                        </div>
                      )}
                    </div>
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </div>

          <div className="range-products-section">
            <h2 className="range-products-title">Range Products</h2>
            <Grid container spacing={2} justifyContent="center" className="range-products-grid">
              {rangeLoading
                ? Array.from({ length: 6 }).map((_, index) => (
                    <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
                      <div className="shimmer-placeholder-neuro range-product-shimmer" />
                    </Grid>
                  ))
                : rangeProductAPIData.map((product) => (
                    <Grid item xs={6} sm={4} md={3} lg={2} key={product.id}>
                      <button
                        type="button"
                        className="range-product-btn"
                        onClick={() => handleRangeClick(product)}
                      >
                        {product?.title}
                      </button>
                    </Grid>
                  ))
              }
            </Grid>
          </div>
        </div>
      )}
    </div>
  );
};

export default Division1;
